
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneakers/upper-material/[upperMaterialValue]",
      function () {
        return require("private-next-pages/sneakers/upper-material/[upperMaterialValue].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneakers/upper-material/[upperMaterialValue]"])
      });
    }
  